module.exports = __webpack_public_path__ + "img/close-button.70ae0b08.svg";